export default class AccentStyleCreator {
  public static styleSheet: CSSStyleSheet;

  public static createAccentColorStyle(color: string) {
    if (!this.styleSheet) {
      const styleElement: HTMLStyleElement = document.createElement('style');
      document.head.appendChild(styleElement);
      this.styleSheet = styleElement.sheet as CSSStyleSheet;
    }
    while (this.styleSheet.cssRules.length > 0) {
      this.styleSheet.deleteRule(0);
    }

    // Styles
    this.styleSheet.insertRule(`.text-accent { color: ${color} }`, 0);
    this.styleSheet.insertRule(
      `.bg-accent{background-color: ${color}!important;border-color: ${color}!important; }`,
      0,
    );
    this.styleSheet.insertRule(`.shadow-accent{box-shadow: 0 10px 35px -10px ${color}}`, 0);
    this.styleSheet.insertRule(`.border-accent{border-color: ${color}}`, 0);

    // Theme Color
    const metaThemeColor = document.querySelector('meta[name=theme-color]');
    if (metaThemeColor) metaThemeColor.setAttribute('content', color);
    const metaThemeColor2 = document.querySelector('meta[name=apple-mobile-web-app-status-bar-style]');
    if (metaThemeColor2) metaThemeColor2.setAttribute('content', color);
  }
}
